export const P00043SensContactSelEnum = [
  { ref: 0, label: 'P00043.senscontactsel.0' },
  { ref: 1, label: 'P00043.senscontactsel.1' },
];
